
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ListProductsService } from './services/list-products.service';
import { ProductsComponent } from "../products/products.component";
import { EmptyProductsEstablishmentComponent } from "../../../../shared/components/empty-products-establishment/empty-products-establishment.component";
import { Category } from '../categories/interfaces/categories.interface';
import { SearchProductsService } from '../search-bar-products/service/search-products.service';
import { ListCategoriesService } from '../list-categories/service/list-categories.service';
import { ListProductResponse, ProductData } from './interfaces/list-products-new.interface';
import { NgxSkeletonLoaderModule } from "ngx-skeleton-loader";
import { AuthService } from '../../../../core/service/auth.service';
import { SelectedAddressService } from '../../../../core/service/selected-address.service';

@Component({
  selector: 'establishment-main-list-products',
  imports: [ProductsComponent, EmptyProductsEstablishmentComponent, NgxSkeletonLoaderModule],
  templateUrl: './list-products.component.html',
  styleUrl: './list-products.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListProductsComponent implements OnInit {
  products: ProductData[] = [];
  authService = inject(AuthService);
  selectedAddressService = inject(SelectedAddressService);
  loading: boolean = true;
  error: string | null = null;
  selectedCategoryId: number | null = null;
  selectedSubcategoryId: number | null = null;
  establishmentId: string = '';
  categories: Category[] = []; // Añadimos la propiedad para almacenar las categorías
  @Input() isOpen: boolean = false;

  private _filterEvent: any = null;
  @Input()
  set filterEvent(filter: any) {
    this._filterEvent = filter;
    if (filter) {
      this.applyFilter(filter);
    }
  }

  get filterEvent(): any {
    return this._filterEvent;
  }

  private allProducts: ProductData[] = []; // Almacenar todos los productos originales
  private fullProductData: any[] = []; // Almacenar la estructura completa de la respuesta
  constructor(private route: ActivatedRoute,
    private listProductsService: ListProductsService,
    private searchProductsService: SearchProductsService,
    private listCategoriesService: ListCategoriesService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      // console.log('Route params in products:', params);
      const id: string = params['id'];
      // console.log('Establishment ID for products:', id);
      if (id) {
        this.establishmentId = id;
        this.loadProducts(id);
      }
    });
  }

  loadProducts(id: string) {
    if (!this.authService.isLoggedIn()) {
      this.listProductsWithoutLogin(id);
    } else {


      const idAdressUser = this.selectedAddressService.getCurrentSelectedAddress()?.ad_id


      if (idAdressUser) {
        this.listProductsLogin(Number(id), idAdressUser!);
      }
      this.listProductsWithoutLogin(id);
    }



  }

  applyFilter(filter: any): void {
    // console.log('Applying filter:', filter);

    if (!filter || (!filter.categoryId && !filter.subcategoryId)) {
      // Si no hay filtro, mostrar todos los productos
      this.products = [...this.allProducts];
      // console.log('No filter applied, showing all products:', this.products.length);
    } else {
      // Filtrar productos por categoría o subcategoría
      this.products = this.allProducts.filter(product => {
        const productCategoryId = Number((product as any).categoryId);
        const productSubcategoryId = Number((product as any).subcategoryId);

        // Si hay categoryId, filtrar por categoría
        if (filter.categoryId) {
          const filterCategoryId = Number(filter.categoryId);
          return productCategoryId === filterCategoryId;
        }

        // Si hay subcategoryId, filtrar por subcategoría
        if (filter.subcategoryId) {
          const filterSubcategoryId = Number(filter.subcategoryId);
          return productSubcategoryId === filterSubcategoryId;
        }

        return true;
      });
    }

    // console.log('Filtered products count:', this.products.length);
    // console.log('First few filtered products:', this.products.slice(0, 3));

    // Actualizar también el servicio de búsqueda con los productos filtrados
    this.searchProductsService.setProducts(this.products);

    // Forzar detección de cambios para actualizar la UI
    this.cdr.detectChanges();
  }



  listProductsLogin(idEstablishment: number, idAddressUser: number): void {
    this.loading = true;
    this.listProductsService.listProductsLogin(idEstablishment, idAddressUser)
      .subscribe({
        next: (response: ListProductResponse) => {
          // Almacenar la respuesta completa para mantener la estructura de categorías
          this.fullProductData = response.data;

          // Almacenar todos los productos originales con información de categoría
          this.allProducts = response.data.flatMap(category =>
            category.products_subcategories.flatMap(subcategory =>
              subcategory.products.map(product => ({
                ...product,
                categoryId: category.pg_id,
                categoryName: category.pg_name,
                subcategoryId: subcategory.ps_id,
                subcategoryName: subcategory.ps_name
              }))
            )
          );

          // Mostrar todos los productos inicialmente
          this.products = [...this.allProducts];

          this.searchProductsService.setProducts(this.products);
          // console.log('productos en products', this.products);
          // console.log('fullProductData structure:', this.fullProductData);

          this.loading = false;
          this.cdr.detectChanges(); // Forzar detección de cambios
          // console.log('Products loaded:', this.products);
        },
        error: (error) => {
          this.error = error.message;
          if (error.status === 422) {
            this.error = error.error.message;
          }
          this.loading = false;
          this.cdr.detectChanges(); // Forzar detección de cambios

        }
      });
  }


  listProductsWithoutLogin(idEstablishment: string): void {

    this.loading = true;
    // console.log('Loading products for establishment ID:', id);
    // Cargar productos
    this.listProductsService.listProducts(idEstablishment)
      .subscribe({
        next: (response: ListProductResponse) => {
          // Almacenar la respuesta completa para mantener la estructura de categorías
          this.fullProductData = response.data;

          // Almacenar todos los productos originales con información de categoría
          this.allProducts = response.data.flatMap(category =>
            category.products_subcategories.flatMap(subcategory =>
              subcategory.products.map(product => ({
                ...product,
                categoryId: category.pg_id,
                categoryName: category.pg_name,
                subcategoryId: subcategory.ps_id,
                subcategoryName: subcategory.ps_name
              }))
            )
          );

          // Mostrar todos los productos inicialmente
          this.products = [...this.allProducts];

          this.searchProductsService.setProducts(this.products);
          // console.log('productos en products', this.products);
          // console.log('fullProductData structure:', this.fullProductData);

          this.loading = false;
          this.cdr.detectChanges(); // Forzar detección de cambios
          // console.log('Products loaded:', this.products);
        },
        error: (error) => {
          this.error = 'Error loading products';
          this.loading = false;
          this.cdr.detectChanges(); // Forzar detección de cambios
          console.error('Error loading products:', error);
        }
      });
  }
}
